import { ErrorBoundary, ErrorFallback } from "etl/features";
import { WithAntd } from "./WithAntd";
import { WithCSSImports } from "./WithCSSImports";
import { WithDateConfig } from "./WithDateConfig";
import { WithRedux } from "./WithRedux";
import { WithRouter } from "./WithRouter";
import { WithSentry } from "./WithSentry";
import { WithToast } from "./WithToast";
import { initStore } from "etl/core";
import { awAxiosClient, etlAxiosClient } from "etl/services";
import { browserLocalStorage, navigationService } from "etl/services";
import { WithNavigation } from "./WithNavigation";

export interface AllProvidersProps {
    children: React.ReactNode
}

export const AllProviders = (props: AllProvidersProps) => {
    const { children } = props;

    return (
        <WithSentry>
            <WithToast>
                <WithRedux
                    store={initStore({
                        etlClient: etlAxiosClient,
                        awClient: awAxiosClient,
                        localStorage: browserLocalStorage,
                        navigationService: navigationService
                    })}>
                    <WithCSSImports>
                        <WithAntd>
                            <WithDateConfig>
                                <WithRouter>
                                    <WithNavigation>
                                        <ErrorBoundary fallback={ErrorFallback.PAGE}>
                                            {children}
                                        </ErrorBoundary>
                                    </WithNavigation>
                                </WithRouter>
                            </WithDateConfig>
                        </WithAntd>
                    </WithCSSImports>
                </WithRedux>
            </WithToast>
        </WithSentry>
    );
};
